import React from "react";


export default function Bottom(props) {
  return (
    <section className="bottom">

      <div className="container">
        <div className="content text-center p-2">
          <small className="copyright">
            <span>Copyright © {new Date().getFullYear()} iStore Pty Ltd. ABN: 54152166160</span>
          </small>
        </div>
      </div>
    </section>
  );
}
